export const MARKER_SESSION_STORAGE_KEY = "omnicine:timeline:marker-session";

export function writePersistedMarkerSession(markers: unknown[]): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(MARKER_SESSION_STORAGE_KEY, JSON.stringify(markers));
  } catch {
    // ignore storage failures
  }
}

export function removeTimelineMarkersWithPersistence(args: {
  dispatch: (action: any) => void;
  markers: unknown[];
  markerIds: string[];
  markerNote: string;
  annotationNote?: string;
  source?: string;
}): string[] {
  const normalizedIds = args.markerIds
    .map((markerId) => String(markerId ?? "").trim())
    .filter(Boolean);
  if (!normalizedIds.length) return [];

  const removeSet = new Set(normalizedIds);
  const removedMarkers = (args.markers ?? []).filter((marker: any) => removeSet.has(String(marker?.id ?? "").trim()));

  if (args.annotationNote) {
    const annotationIds = Array.from(new Set(
      removedMarkers
        .map((marker: any) => String(marker?.annotation?.annotationId ?? "").trim())
        .filter(Boolean),
    ));

    for (const annotationId of annotationIds) {
      args.dispatch({
        type: "annotation/update",
        payload: {
          annotationId,
          patch: {
            markerVisible: false,
          },
        },
        meta: { source: args.source ?? "user", note: args.annotationNote },
      } as any);
    }
  }

  writePersistedMarkerSession(
    (args.markers ?? []).filter((marker: any) => !removeSet.has(String(marker?.id ?? "").trim())),
  );

  for (const markerId of normalizedIds) {
    args.dispatch({
      type: "marker/remove",
      payload: { markerId },
      meta: { source: args.source ?? "user", note: args.markerNote },
    } as any);
  }

  return normalizedIds;
}